import { render, staticRenderFns } from "./dialog-table.vue?vue&type=template&id=a71f31b2"
import script from "./dialog-table.vue?vue&type=script&setup=true&lang=js"
export * from "./dialog-table.vue?vue&type=script&setup=true&lang=js"
import style0 from "./dialog-table.vue?vue&type=style&index=0&id=a71f31b2&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/.pnpm/vue-loader@15.11.1_5cxdem7bu5cwsxatf4y6tpyoxu/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports